// AUTOGENERATED: DO NOT EDIT

import {
  AnimatedSprite,
  Spritesheet,
  ISpritesheetData,
  Texture,
  SCALE_MODES,
} from "pixi.js";
import img from "../../assets/img/cool/cool.png";
import { SpriteSheetJSON } from "./type";

const data: SpriteSheetJSON = {
  frames: {
    "cool 0.aseprite": {
      frame: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 1.aseprite": {
      frame: {
        x: 374,
        y: 0,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 2.aseprite": {
      frame: {
        x: 748,
        y: 0,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 3.aseprite": {
      frame: {
        x: 1122,
        y: 0,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 4.aseprite": {
      frame: {
        x: 1496,
        y: 0,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 5.aseprite": {
      frame: {
        x: 1870,
        y: 0,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 6.aseprite": {
      frame: {
        x: 2244,
        y: 0,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 7.aseprite": {
      frame: {
        x: 0,
        y: 396,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 8.aseprite": {
      frame: {
        x: 374,
        y: 396,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 9.aseprite": {
      frame: {
        x: 748,
        y: 396,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 10.aseprite": {
      frame: {
        x: 1122,
        y: 396,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 11.aseprite": {
      frame: {
        x: 1496,
        y: 396,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 12.aseprite": {
      frame: {
        x: 1870,
        y: 396,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 13.aseprite": {
      frame: {
        x: 2244,
        y: 396,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 14.aseprite": {
      frame: {
        x: 0,
        y: 792,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 15.aseprite": {
      frame: {
        x: 374,
        y: 792,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 16.aseprite": {
      frame: {
        x: 748,
        y: 792,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 17.aseprite": {
      frame: {
        x: 1122,
        y: 792,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 18.aseprite": {
      frame: {
        x: 1496,
        y: 792,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 19.aseprite": {
      frame: {
        x: 1870,
        y: 792,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 20.aseprite": {
      frame: {
        x: 2244,
        y: 792,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 21.aseprite": {
      frame: {
        x: 0,
        y: 1188,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 22.aseprite": {
      frame: {
        x: 374,
        y: 1188,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 23.aseprite": {
      frame: {
        x: 374,
        y: 1188,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 24.aseprite": {
      frame: {
        x: 374,
        y: 1188,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 25.aseprite": {
      frame: {
        x: 748,
        y: 1188,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 26.aseprite": {
      frame: {
        x: 1122,
        y: 1188,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 27.aseprite": {
      frame: {
        x: 1496,
        y: 1188,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 28.aseprite": {
      frame: {
        x: 1870,
        y: 1188,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 29.aseprite": {
      frame: {
        x: 2244,
        y: 1188,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 30.aseprite": {
      frame: {
        x: 0,
        y: 1584,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 31.aseprite": {
      frame: {
        x: 374,
        y: 1584,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 32.aseprite": {
      frame: {
        x: 748,
        y: 1584,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 33.aseprite": {
      frame: {
        x: 1122,
        y: 1584,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 34.aseprite": {
      frame: {
        x: 1496,
        y: 1584,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 35.aseprite": {
      frame: {
        x: 1870,
        y: 1584,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 36.aseprite": {
      frame: {
        x: 2244,
        y: 1584,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 37.aseprite": {
      frame: {
        x: 0,
        y: 1980,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 38.aseprite": {
      frame: {
        x: 374,
        y: 1980,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 39.aseprite": {
      frame: {
        x: 748,
        y: 1980,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 40.aseprite": {
      frame: {
        x: 1122,
        y: 1980,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 41.aseprite": {
      frame: {
        x: 1496,
        y: 1980,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 42.aseprite": {
      frame: {
        x: 1870,
        y: 1980,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 43.aseprite": {
      frame: {
        x: 2244,
        y: 1980,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 44.aseprite": {
      frame: {
        x: 0,
        y: 2376,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 45.aseprite": {
      frame: {
        x: 374,
        y: 2376,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 46.aseprite": {
      frame: {
        x: 748,
        y: 2376,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
    "cool 47.aseprite": {
      frame: {
        x: 748,
        y: 2376,
        w: 374,
        h: 396,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 374,
        h: 396,
      },
      sourceSize: {
        w: 374,
        h: 396,
      },
      duration: 100,
    },
  },
  meta: {
    app: "https://www.aseprite.org/",
    version: "1.3.9.2-arm64",
    image: "cool.png",
    format: "RGBA8888",
    size: {
      w: 2618,
      h: 2772,
    },
    scale: "1",
    frameTags: [],
    layers: [
      {
        name: "Layer",
        opacity: 255,
        blendMode: "normal",
      },
    ],
    slices: [],
  },
  animations: {
    anim: [
      "cool 0.aseprite",
      "cool 1.aseprite",
      "cool 2.aseprite",
      "cool 3.aseprite",
      "cool 4.aseprite",
      "cool 5.aseprite",
      "cool 6.aseprite",
      "cool 7.aseprite",
      "cool 8.aseprite",
      "cool 9.aseprite",
      "cool 10.aseprite",
      "cool 11.aseprite",
      "cool 12.aseprite",
      "cool 13.aseprite",
      "cool 14.aseprite",
      "cool 15.aseprite",
      "cool 16.aseprite",
      "cool 17.aseprite",
      "cool 18.aseprite",
      "cool 19.aseprite",
      "cool 20.aseprite",
      "cool 21.aseprite",
      "cool 22.aseprite",
      "cool 23.aseprite",
      "cool 24.aseprite",
      "cool 25.aseprite",
      "cool 26.aseprite",
      "cool 27.aseprite",
      "cool 28.aseprite",
      "cool 29.aseprite",
      "cool 30.aseprite",
      "cool 31.aseprite",
      "cool 32.aseprite",
      "cool 33.aseprite",
      "cool 34.aseprite",
      "cool 35.aseprite",
      "cool 36.aseprite",
      "cool 37.aseprite",
      "cool 38.aseprite",
      "cool 39.aseprite",
      "cool 40.aseprite",
      "cool 41.aseprite",
      "cool 42.aseprite",
      "cool 43.aseprite",
      "cool 44.aseprite",
      "cool 45.aseprite",
      "cool 46.aseprite",
      "cool 47.aseprite",
    ],
  },
};

let spritesheet: Spritesheet;

export const loadcool = async () => {
  const texture = Texture.from(img);
  texture.baseTexture.scaleMode = SCALE_MODES.NEAREST;

  spritesheet = new Spritesheet(texture, data as ISpritesheetData);

  return spritesheet.parse();
};

export const cool = () => {
  const anim = new AnimatedSprite(spritesheet.animations.anim);

  anim.width = 748;
  anim.height = 792;
  anim.anchor.set(0.5, 0.5);

  return anim;
};
